// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

// AOS
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init({
    duration: 800,
    easing: "ease-out",
    offset: 40,
    once: true,
});

// Optional: basename aus Env (z.B. /shop für Live; lokal /)
const BASENAME = process.env.REACT_APP_BASENAME || "/";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <BrowserRouter basename={BASENAME}>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);
